import { g as s } from "./_commonjsHelpers-DaMA6jEr.js";
import { _ as l } from "./_baseClone-CPYgn-G_.js";
import { i as m } from "./isEqual-Ctt-Lv3H.js";
import { ref as c, watch as a } from "vue";
var f = l, i = 4;
function p(r) {
  return f(r, i);
}
var _ = p;
const n = /* @__PURE__ */ s(_), L = (r, t, u) => {
  const e = c(n(r[t]));
  return a(() => r[t], (o) => {
    m(o, e.value) || (e.value = n(o));
  }), a(e, (o) => {
    u(`update:${t}`, o);
  }, { deep: !0 }), e;
};
export {
  L as u
};
